import React, { useState, useEffect } from "react";
import { Award, Lightbulb, Leaf, Heart, Shield } from "lucide-react";

const ValuesSection = () => {
  const values = [
    {
      icon: <Award className="w-10 h-10" />,
      title: "Excellence",
      description:
        "Delivering world-class solutions that exceed expectations and drive meaningful impact across all our ventures and partnerships.",
      color: "from-blue-500 to-blue-600",
    },
    {
      icon: <Shield className="w-10 h-10" />,
      title: "Tradition",
      description:
        "Honoring African heritage while embracing global best practices and innovation to create sustainable value.",
      color: "from-emerald-500 to-emerald-600",
    },
    {
      icon: <Lightbulb className="w-10 h-10" />,
      title: "Innovation",
      description:
        "Pioneering cutting-edge solutions that shape the future of African business and global commerce.",
      color: "from-yellow-500 to-yellow-600",
    },
    {
      icon: <Leaf className="w-10 h-10" />,
      title: "Sustainability",
      description:
        "Building for tomorrow with environmentally conscious and socially responsible practices that benefit all stakeholders.",
      color: "from-emerald-500 to-blue-500",
    },
  ];

  return (
    <section id="values" className="py-24 bg-white relative overflow-hidden">
      {/* Background pattern */}
      <div
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%2334d399' fill-opacity='1'%3E%3Cpath d='m36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}
      ></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <div className="inline-block p-3 bg-gradient-to-r from-emerald-500/10 to-blue-500/10 rounded-full mb-6 border border-emerald-200">
            <Heart className="w-8 h-8 text-emerald-600" />
          </div>
          <h2 className="text-5xl md:text-7xl font-black text-slate-900 mb-8">
            Our{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-600 via-blue-600 to-yellow-500">
              Core Values
            </span>
          </h2>
          <div className="w-32 h-1.5 bg-gradient-to-r from-emerald-500 via-blue-500 to-yellow-500 mx-auto mb-10 rounded-full"></div>
          <p className="text-2xl text-slate-600 max-w-4xl mx-auto font-light">
            These fundamental principles guide every decision we make and every
            relationship we build across our growing portfolio.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {values.map((value, index) => (
            <div key={index} className="group text-center">
              <div className="bg-gradient-to-br from-slate-50 to-blue-50/30 hover:from-emerald-50/50 hover:to-blue-50/50 rounded-3xl p-10 transition-all duration-500 transform hover:-translate-y-4 shadow-xl hover:shadow-2xl border border-slate-200/50 hover:border-emerald-200/50 h-full flex flex-col">
                <div
                  className={`inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br ${value.color} rounded-2xl text-white mb-8 group-hover:scale-110 transition-all duration-300 shadow-lg mx-auto`}
                >
                  {value.icon}
                </div>
                <h3 className="text-2xl font-bold text-slate-900 mb-6 group-hover:text-transparent group-hover:bg-clip-text group-hover:bg-gradient-to-r group-hover:from-emerald-600 group-hover:to-blue-600 transition-all duration-300">
                  {value.title}
                </h3>
                <p className="text-slate-600 leading-relaxed text-lg flex-grow">
                  {value.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
export default ValuesSection;
